import { ungroupStpGroup } from 'components/Graph/commands/ungroupStpGroup';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export type UpdateStpInstanceIsolateCommand = {
  isolate: boolean;
};

export const updateStpInstanceIsolate: GraphCommandFactory<
  UpdateStpInstanceIsolateCommand
> = (cmdContext, dispatch) => (command) => {
  cmdContext.updateState((draft) => {
    const {
      technologies: {
        selectedTechnologies: { stpInstances },
      },
    } = draft;
    if (!stpInstances) {
      return;
    }
    stpInstances.isolate = command.isolate;
  });

  dispatch(ungroupStpGroup);
};
